module.exports = __webpack_public_path__ + "static/media/SentinelSSm-Book.ff035a93.otf";